import { gql } from '@apollo/client';

export const ATTRIBUTES = gql`
  query attributes {
    attributes {
      id
      name
      label
      description
      icon
      values
      configs
    }
  }
`;

export default ATTRIBUTES;
